<style scoped>
.pages-box {
  width: 100%;
  height: 100vh;
  background-color: #eff1f6;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  box-sizing: border-box;
}
.institution_content {
  max-width: 600px;
  background-color: #ffffff;
  border-radius: 15px;
  padding: 10px 10px 5px;
}

.institution_item {
  padding: 8px;
  background-color: #00000006;
  border-radius: 6px;
  margin-bottom: 6px;
  font-size: 16px;
}

.between {
  justify-content: space-between;
}
.institution_content_title {
  font-weight: 600;
  color: #000000;
  margin-bottom: 6px;
  font-size: 17px;
  padding: 0 2px;
}
.footers {
  width: 100%;
  height: 30px;
}
</style>

<template>
  <div class="pages-box">
    <div class="institution_content">
      <div class="institution_content_title" style="">制度相关公示</div>
      <div v-for="(item, index) in list" :key="index">
        <div
          class="flex institution_item between"
          @click="path(item.path, item.title)"
        >
          <div>{{ item.title }}</div>
          <img :src="item.incone" alt="" />
        </div>
      </div>
    </div>

    <div class="institution_content">
      <div class="institution_content_title" style="">规范</div>
      <div v-for="(item, index) in institution_list" :key="index">
        <div
          class="flex institution_item between"
          @click="path(item.path, item.title)"
        >
          <div>{{ item.title }}</div>
          <img :src="item.incone" alt="" />
        </div>
      </div>
    </div>

    <div class="institution_content">
      <div class="institution_content_title">协议/规则</div>
      <div v-for="(item, index) in agreementRule" :key="index">
        <div
          class="flex institution_item between"
          @click="path(item.path, item.title)"
        >
          <div>{{ item.title }}</div>
          <img :src="item.incone" alt="" />
        </div>
      </div>
    </div>
    <div class="footers"></div>
  </div>
</template>

<script>
import icon_right from "./right.svg";

export default {
  data() {
    return {
      institution_list: [
        {
          title: "入网餐饮服务提供者审查登记规范",
          incone: icon_right,
          path: "/Merchant_residence_agreement",
        },
        {
          title: "美滋来平台商户违规作弊管理规范",
          incone: icon_right,
          path: "/Cheating_management_standard",
        },
        {
          title: "美滋来平台用户评价规范",
          incone: icon_right,
          path: "User_evaluation_specification",
        },
        {
          title: "美滋来平台隐私权政策",
          incone: icon_right,
          path: "Privacy_policy",
        },
      ],

      list: [
        {
          title: "入网食品生产经营者审查登记制度",
          incone: icon_right,
          path: "dispensation1",
        },
        {
          title: "食品安全自查制度",
          incone: icon_right,
          path: "dispensation2",
        },
        {
          title: "食品安全违法行为制止及报告制度",
          incone: icon_right,
          path: "dispensation3",
        },
        {
          title: "食品安全投诉举报处理制度",
          incone: icon_right,
          path: "dispensation4",
        },
        {
          title: "严重违法行为平台服务停止制度",
          incone: icon_right,
          path: "dispensation5",
        },
      ],

      agreementRule: [
        {
          title: "美滋来平台消费者权益保障措施",
          incone: icon_right,
          path: "Protection_of_rights_and_interests",
        },
        {
          title: "美滋来平台商户入驻协议",
          incone: icon_right,
          path: "/registration_norms",
        },
        {
          title: "美滋来平台商户信息发布管理规范",
          incone: icon_right,
          path: "Release_management_norms",
        },
        {
          title: "美滋来平台交易规则",
          incone: icon_right,
          path: "Transaction_rules",
        },
        {
          title: "美滋来用户服务协议",
          incone: icon_right,
          path: "User_service_agreement",
        },
      ],
    };
  },
  created() {
    document.title = "服务协议及相关规则"; // 修改页面的标题
  },
  methods: {
    path(url, title) {
      this.$router.push({
        path: url,
        query: {
          data: title,
        },
      });
    },
  },
};
</script>
